const env = (key, fallback) => {
    const value = import.meta.env[`VITE_APP_${key}`];
    return value !== undefined ? value : fallback;
};

const envString = (key, fallback) => String(env(key, fallback));
export const PRODUCTION_API_DOMAIN = "https://api.slynumber.com";
const DEVELOPMENT_API_DOMAIN = envString("DEV_DOMAIN", "/api");

export const DOMAIN =  envString("DOMAIN", DEVELOPMENT_API_DOMAIN);
export const SITE_NAME = envString("SITE_NAME", "SLYNUMBER");
export const HOME_URL = envString("HOME_URL", "slynumber.com");
export const REDIRECT_URI = envString("REDIRECT_URI", "https://slynumber.com/app");
export const FB_APP_ID = envString("FB_APP_ID", "");
export const APPLE_ID = envString("APPLE_ID", "");
export const GG_APP_ID = envString(
    "GG_APP_ID",
    ""
);
export const STRIPEKEY = envString(
    "STRIPEKEY",
    ""
);

export const PROFILE_KEY = "slynumber.user_profile";
export const SUBSCRIPTION_KEY = "slynumber.subscription";
export const PLANS_KEY = "slynumber.plans";
export const CREDITS_KEY = "slynumber.credits";
export const ACTIVE_SUB_KEY = "slynumber.active_sub";
export const PHONE_NUMBER_KEY = "slynumber.phone_number_choosen";
export const USER_INFO_KEY = "slynumber.user_info_key";
export const TOKEN_KEY = "slynumber.token";
export const SELECT_PLAN_KEY = "slynumber.select_plan_key";
export const SELECT_PLAN_NAME_KEY = "slynumber.select_plan_name_key";
export const UUID_KEY = "slynumber.uuid";
export const DEVICES_KEY = "slynumber.devices";
export const RECAPTCHA_SITE_KEY = envString("RECAPTCHA_SITE_KEY", "");
export const GCLID_KEY = "slynumber.gclid";
export const FBCLID_KEY = "slynumber.fbclid";

export const STRIPE_APPEARANCE = {
    theme: "stripe",
    variables: {
        colorPrimary: "#000000",
        colorBackground: "#ffffff",
        colorText: "#1a1a1a",
        colorDanger: "#ff4d4f",
        fontFamily: "inherit",
        borderRadius: "8px",
        spacingUnit: "4px",
    },
    rules: {
        ".Input": {
            border: "1px solid #d9d9d9",
            padding: "12px",
            fontSize: "14px",
        },
        ".Input:focus": {
            borderColor: "#000000",
            boxShadow: "none",
        },
    },
};
